"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProposalNurseSummaryDto = instanceOfProposalNurseSummaryDto;
exports.ProposalNurseSummaryDtoFromJSON = ProposalNurseSummaryDtoFromJSON;
exports.ProposalNurseSummaryDtoFromJSONTyped = ProposalNurseSummaryDtoFromJSONTyped;
exports.ProposalNurseSummaryDtoToJSON = ProposalNurseSummaryDtoToJSON;
exports.ProposalNurseSummaryDtoToJSONTyped = ProposalNurseSummaryDtoToJSONTyped;
/**
 * Check if a given object implements the ProposalNurseSummaryDto interface.
 */
function instanceOfProposalNurseSummaryDto(value) {
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('avatar' in value) || value['avatar'] === undefined)
        return false;
    if (!('proposedRate' in value) || value['proposedRate'] === undefined)
        return false;
    if (!('proposedDate' in value) || value['proposedDate'] === undefined)
        return false;
    if (!('proposedStartTime' in value) || value['proposedStartTime'] === undefined)
        return false;
    if (!('proposedEndTime' in value) || value['proposedEndTime'] === undefined)
        return false;
    if (!('comment' in value) || value['comment'] === undefined)
        return false;
    return true;
}
function ProposalNurseSummaryDtoFromJSON(json) {
    return ProposalNurseSummaryDtoFromJSONTyped(json, false);
}
function ProposalNurseSummaryDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'id': json['id'] == null ? undefined : json['id'],
        'avatar': json['avatar'],
        'proposedRate': json['proposedRate'],
        'proposedDate': (json['proposedDate'] == null ? null : new Date(json['proposedDate'])),
        'proposedStartTime': (json['proposedStartTime'] == null ? null : new Date(json['proposedStartTime'])),
        'proposedEndTime': (json['proposedEndTime'] == null ? null : new Date(json['proposedEndTime'])),
        'comment': json['comment'],
    };
}
function ProposalNurseSummaryDtoToJSON(json) {
    return ProposalNurseSummaryDtoToJSONTyped(json, false);
}
function ProposalNurseSummaryDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'id': value['id'],
        'avatar': value['avatar'],
        'proposedRate': value['proposedRate'],
        'proposedDate': (value['proposedDate'] == null ? null : value['proposedDate'].toISOString()),
        'proposedStartTime': (value['proposedStartTime'] == null ? null : value['proposedStartTime'].toISOString()),
        'proposedEndTime': (value['proposedEndTime'] == null ? null : value['proposedEndTime'].toISOString()),
        'comment': value['comment'],
    };
}
//# sourceMappingURL=ProposalNurseSummaryDto.js.map